import { AdbDaemonWebUsbDeviceManager } from "@yume-chan/adb-daemon-webusb";
import { ADB_DEFAULT_DEVICE_FILTER } from "@yume-chan/adb-daemon-webusb";
import AdbWebCredentialStore from "@yume-chan/adb-credential-web";
import { AdbDaemonTransport, Adb, AdbSubprocessShellProtocol } from "@yume-chan/adb";

const konsole = document.querySelector("#konsole");
const CredentialStore = new AdbWebCredentialStore();

console.log("hi friend!");
log(navigator.usb)
const Manager = AdbDaemonWebUsbDeviceManager.BROWSER;

if (!Manager) {
  alert("WebUSB is not supported in this browser!\nWe need WebUSB in order to function.\nPlease try again with Google Chrome.");
  return;
} else {
  log("Yay, you have WebUSB!");
}

let device = null;
let devices = null;
let connection = null;
let adb = null;
export let onmonitor = null;
export let dev_list = null;
export let autoconnect_enabled = localStorage["autoconnect_enabled"] || "true";
// switch (localStorage["autoconnect_enabled"]){
//   case "true":
//     autoconnect_enabled = true;
//     break;
//   case "false":
//     autoconnect_enabled = false;
//     break;
//   default:
//     set_autoconnect(true);
//     break;
// }


export function is_device() {
  return !!(device);
}

export function is_connected() {
  return !!(connection)
}

export async function pair_device() {
  await Manager.requestDevice({
    filters: [
      {
        ...ADB_DEFAULT_DEVICE_FILTER,
        vendorId: 0x19D2,
        productId: 0x0452
      }
    ]
  });
  await autoconnect();
}

export async function list_existing() {
  devices = await Manager.getDevices(
    [
      {
        ...ADB_DEFAULT_DEVICE_FILTER,
        vendorId: 0x19D2,
        productId: 0x0452
      }
    ]
  );
  return devices;
}

export function select_existing(serial) {
  device = devices.filter(dev => { return dev.serial == serial; });
  console.log(device);
  if (device.length < 1) {
    device = null;
    return;
  }
  device = device[0];
  if (get_autoconnect()) {
    connect_device();
  }
}

export async function disconnect() {
  if (!device) {
    log("No device connected!")
    return;
  }
  try {
    await adb.close();
  } catch (e) {
    log("Error when closing adb");
    console.error(e);
  }
  log("ADB session closed");
  adb = null;
  try {
    await device.raw.close();
  } catch (e) {
    log("Error when closing connection");
    console.error(e);
  }
  log("Connection closed");
  connection = null;
  device = null;
  if (dev_list) {
    await draw_device_list();
  }
  if (onmonitor) {
    onmonitor();
  }
}

export async function autoconnect() {
  await list_existing();
  if (device && devices.filter(dev => { return dev.serial == device.serial }).length < 1) {
    device = null;
  }
  console.log(devices);
  // if (devices.length == 0) return [];
  if (!device && get_autoconnect() && devices.length > 0) {
    device = devices[0]
    await connect_device();
    if (onmonitor) {
      onmonitor();
    }
  }
  if (dev_list) {
    await draw_device_list();
  }
  return devices;
}

export function set_autoconnect(val) {
  val = "" + val;
  autoconnect_enabled = val;
  localStorage["autoconnect_enabled"] = val;
}

export function get_autoconnect() {
  return autoconnect_enabled == "true";
}

export function monitor_usb(dev_list_p, onmonitor_p) {
  dev_list = dev_list_p;
  onmonitor = onmonitor_p;
  navigator.usb.addEventListener("connect", () => {
    log("Connect event received, updating devices...");
    autoconnect();
  });
  navigator.usb.addEventListener("disconnect", () => {
    log("Disconnect event received, updating devices...");
    autoconnect();
  });
  log("Checking devices due to start...");
  autoconnect();
}

export async function draw_device_list() {
  const list_elem = dev_list;
  if (!devices) {
    await list_existing();
  }
  // log(devices.toString());
  list_elem.innerHTML = `<option value="null">No device</option>`;
  for (const dev of devices) {
    const opt = document.createElement("option");
    opt.textContent = `${dev.raw.productName}\t${dev.raw.manufacturerName}\t${dev.serial}`;
    opt.value = dev.serial;
    list_elem.appendChild(opt);
  }
  if (device) {
    list_elem.value = device.serial;
  } else {
    list_elem.value = "null";
  }
}

export async function connect_device() {
  console.log("connect dev")
  if (!device) {
    console.log("Device is null");
    alert("Device is null");
    return;
  }
  connection = await device.connect();
  log("Device connection opened...")
  const transport = await AdbDaemonTransport.authenticate({
    serial: device.serial,
    connection,
    credentialStore: CredentialStore,
  });
  log("ADB transport opened...")
  adb = new Adb(transport);
  log("ADB connection created!");
  // console.log(adb);
  log("Android version: " + await adb.getProp("ro.build.version.release"));
  if (onmonitor) {
    onmonitor();
  }
}

export async function exploit_gabb() {
  let res = null;
  await godo("am switch-user 0");
  res = await godo("pm list users");
  const mmus = res.stdout.matchAll(/(?<uid>\d+):MaintenanceModeUser:/g);
  for (const mmu of mmus) {
    if (mmu.groups.uid) {
      await godo("pm remove-user " + mmu.groups.uid);
    }
  }
  await godo("pm disable-user --user 0 com.gabb.packageupdater");
  await godo("pm disable-user --user 0 com.zte.zdm");
  log("Exploited (if no errors above, lol)!");
}

export async function install_app(file, user) {
  if (!user) {
    user = "current";
  }
  //const file_input = document.querySelector("#apk");
  //const file = file_input.files[0];
  log("Acquiring sync...");
  const sync = await adb.sync();
  log("Sending APK...");
  await sync.write({ filename: "/data/local/tmp/temp.apk", file: file.stream() });
  sync.dispose();
  log("APK sent!");
  let res = null;
  log("Installing...");
  res = await godo("pm install-create -d --user " + user);
  const session = res.stdout.split("[")[1].split("]")[0];
  await godo(`pm install-write ${session} tomato /data/local/tmp/temp.apk`);
  await godo(`pm install-commit ${session}`);
  await adb.rm("/data/local/tmp/temp.apk");
}

export async function send_command_and_get_response(command, ignore_errors, silence_logs) {
  const process = await adb.subprocess.spawnAndWait(command, {
    protocols: [AdbSubprocessShellProtocol]
  });
  if (process.stderr) {
    if (!silence_logs) {
      log(process.stderr);
    }
    if (!ignore_errors) {
      throw process.stderr;
    }
  }
  if (!silence_logs) {
    log(process.stdout);
  }
  return process;
}

const command_history = [];
let command_lock = 0;

export async function run_user_command(runner) {
  
  if (runner.value.startsWith("adb shell ")) {
    log("Removing \"adb shell \" from command...");
    runner.value = runner.value.substring(10);
  }
  command_history.push(runner.value);
  command_lock = command_history.length;
  await godo(runner.value);
  runner.value = "";
  runner.focus();
}

export function navigate_in_time(step, runner) {
  const comstep = command_lock + step;
  // console.log(comstep, command_history);
  if (comstep > command_history.length || comstep < 0) return;
  if (comstep == command_history.length) {
    runner.value = "";
    command_lock = comstep;
    return;
  }
  command_lock = comstep;
  runner.value = command_history[comstep];
}

export async function start_wifi_adb() {
  log(await adb.tcpip.setPort(5555));
}

export async function stop_wifi_adb() {
  log(await adb.tcpip.disable());
}


export async function send_to_device(file) {
  log("Acquiring sync...");
  const sync = await adb.sync();
  log("Sending...");
  await sync.write({ filename: "/sdcard/Download/" + file.name, file: file.stream() });
  await sync.dispose();
  log("Sent!");
}

export const godo = send_command_and_get_response;

export function log(msg) {
  if (konsole) {
    konsole.textContent += `[${(new Date()).toLocaleString()}] ${msg}\n`
    konsole.scrollTo(0, konsole.scrollHeight);
  } else {
    console.log(msg);
  }
  return msg;
}